<template>
  <div class="pt-3 h-full overflow-hidden flex flex-col">
    <div class="flex flex-wrap gap-x-5 mb-2 items-center">
      <c_cell title="司机关键字">
        <el-input
          v-model="state.params.keywords_car"
          clearable
          placeholder="关键字"
          @keyup.enter="onLoad()"
          @clear="onLoad()"
          class="!w-56"
        >
          <template #suffix>
            <el-icon
              @click="onLoad()"
              color="#a2a2a2"
              title="搜索"
              class="font-bold cursor-pointer hover:opacity-60"
              ><Search
            /></el-icon>
          </template>
        </el-input>
      </c_cell>
      <c_cell title="乘客关键字">
        <el-input
          v-model="state.params.keywords"
          clearable
          placeholder="关键字"
          @keyup.enter="onLoad()"
          @clear="onLoad()"
          class="!w-56"
        >
          <template #suffix>
            <el-icon
              @click="onLoad()"
              color="#a2a2a2"
              title="搜索"
              class="font-bold cursor-pointer hover:opacity-60"
              ><Search
            /></el-icon>
          </template>
        </el-input>
      </c_cell>
      <c_cell title="服务日期">
        <el-date-picker
          v-model="state.params.date"
          type="date"
          placeholder=""
          value-format="YYYY-MM-DD"
        />
      </c_cell>
      <el-radio-group v-model="state.params.type" @change="onLoad()">
        <el-radio-button
          v-for="item in [{ Text: '全部' }, ...$base.Meeting_Pickup_Car_Type]"
          :key="item.Key"
          :value="item.Key"
          >{{ item.Text }}
        </el-radio-button>
      </el-radio-group>
      <el-button type="primary" @click="onLoad">查询</el-button>
      <li class="flex-1">
        <el-button
          type="info"
          link
          icon="Refresh"
          @click="onReset()"
          style="margin-left: -10px"
        >
          重置
        </el-button>
      </li>
      <el-button type="primary" link @click="onExport" icon="Download">
        导出
      </el-button>
    </div>
    <div class="overflow-x-auto flex flex-col">
      <table
        cellpadding="15"
        style="
          min-width: 100%;
          width: fit-content;
          table-layout: fixed;
          border-collapse: collapse;
          text-align: center;
          font-size: 90%;
        "
      >
        <colgroup>
          <col width="120" />
          <col width="120" />
          <col width="140" />
          <col width="140" />
          <col width="140" />
          <col width="160" />
          <col width="180" />
          <col width="160" />
          <col width="180" />
          <col />
          <col width="80" />
        </colgroup>
        <thead>
          <tr class="bg-gray-100" style="background-color: #f7f7f7">
            <th class="whitespace-nowrap">日期</th>
            <th class="whitespace-nowrap">类型</th>
            <th class="whitespace-nowrap">乘客姓名</th>
            <th class="whitespace-nowrap">联系电话</th>
            <th class="whitespace-nowrap">航班/高铁</th>
            <th class="whitespace-nowrap">接客时间</th>
            <th class="whitespace-nowrap">接客地点</th>
            <th class="whitespace-nowrap">预计送达</th>
            <th class="whitespace-nowrap">送达地点</th>
            <th class="whitespace-nowrap text-left">接客说明</th>
            <th class="whitespace-nowrap pr-2">操作</th>
          </tr>
        </thead>
      </table>
      <div style="overflow-y: auto; overflow-x: hidden; flex: 1">
        <table
          cellpadding="15"
          style="
            min-width: 100%;
            width: fit-content;
            table-layout: fixed;
            border-collapse: collapse;
            text-align: center;
            font-size: 90%;
          "
        >
          <colgroup>
            <col width="120" />
            <col width="120" />
            <col width="140" />
            <col width="140" />
            <col width="140" />
            <col width="160" />
            <col width="180" />
            <col width="160" />
            <col width="180" />
            <col />
            <col width="80" />
          </colgroup>
          <tbody>
            <template v-for="car in state.list_data">
              <tr class="bg-gray-50">
                <td colspan="11">
                  <div class="flex gap-x-5 items-center text-sm">
                    <c_Avatar
                      style="width: 30px; height: 30px"
                      :title="car.driver_name?.slice(0, 1)"
                    />
                    <strong>{{ car.driver_name }}</strong>
                    <el-icon class="ml-5"><phone /></el-icon>
                    <text>{{ car.driver_phone }}</text>
                    <el-icon class="ml-5"><OfficeBuilding /></el-icon>
                    <text>{{ car.driver_company }}</text>
                    <c_cell v-if="car.intro" title="说明" :value="car.intro" />
                    <li class="flex-1"></li>
                    <li
                      class="bg-gray-100 rounded p-2 whitespace-nowrap flex items-center gap-x-1"
                    >
                      <el-image
                        :src="require('@/assets/images/car.png')"
                        class="!w-3"
                      />
                      {{
                        car.number + "/" + car.name + "/" + car.d_car_type_name
                      }}
                    </li>
                    <li class="bg-blue-100 rounded p-2 whitespace-nowrap">
                      {{ car.passenger_capacity + "人" }}
                    </li>
                    <li
                      class="bg-gray-100 rounded p-2 whitespace-nowrap flex items-center gap-x-1"
                    >
                      <el-icon><Calendar /></el-icon>
                      {{
                        $dayjs(car.service_time_start).format(
                          "YYYY-MM-DD",
                        ) +
                        " ~ " +
                        $dayjs(car.service_time_end).format("YYYY-MM-DD")
                      }}
                    </li>
                    <el-button
                      type="primary"
                      icon="plus"
                      link
                      size="small"
                      @click="
                        state.selectCar = car;
                        state.showAdd = true;
                      "
                    >
                      添加接送
                    </el-button>
                  </div>
                </td>
              </tr>
              <template v-for="date in car.dateList">
                <template v-if="date.taskList?.length > 0">
                  <tr v-for="(item, itemIndex) in date.taskList">
                    <td
                      class="border-r border-b py-2 text-center"
                      :rowspan="date.taskList?.length"
                      v-if="itemIndex == 0"
                    >
                      {{ date.date }}
                    </td>
                    <td class="border-b">
                      <c_status
                        arrName="Meeting_Pickup_Car_Type"
                        :value="item.type"
                        :key="item.type"
                        showBg
                      />
                    </td>
                    <td class="border-b">{{ item.name }}</td>
                    <td class="border-b">{{ item.phone }}</td>
                    <td class="border-b">{{ item.transport_no }}</td>
                    <td class="border-b">
                      {{
                        $dayjs(item.reception_time).format("YYYY-MM-DD HH:mm")
                      }}
                    </td>
                    <td class="border-b">{{ item.reception_place }}</td>
                    <td class="border-b">
                      {{
                        $dayjs(item.estimate_send_time).format(
                          "YYYY-MM-DD HH:mm",
                        )
                      }}
                    </td>
                    <td class="border-b">{{ item.send_place }}</td>
                    <td class="border-b text-left">{{ item.pickup_intro }}</td>
                    <td class="border-b">
                      <el-button
                        type="danger"
                        icon="close"
                        link
                        size="small"
                        @click="onCancel(item)"
                      >
                        取消
                      </el-button>
                    </td>
                  </tr>
                </template>
                <tr v-else>
                  <td class="border-r border-b py-2 text-center">
                    {{ date.date }}
                  </td>
                  <td
                    class="border-b text-left pl-5 text-xs text-gray-400"
                    colspan="10"
                  >
                    暂无排班~
                  </td>
                </tr>
              </template>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <c_page
      :total="state.totalCount"
      :pageIndex="state.params.page"
      :pageSize="state.params.limit"
      @onLoad="
        (page) => {
          state.params.page = page.pageIndex;
          state.params.limit = page.pageSize;
          onLoad();
        }
      "
    />
  </div>
  <el-dialog
    v-model="state.showAdd"
    title="添加接送"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showAdd = false;
      }
    "
    style="max-height: 80%"
    width="500"
    append-to="#jiesong"
  >
    <c_add
      :meeting_id="props.meeting_id"
      :meeting_car="state.selectCar"
      @close="
        state.showAdd = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  meeting_service_pickup_car_page,
  meeting_service_pickup_car_cancel,
  meeting_service_pickup_car_export,
} from "@/http/meetingservice";
import { funcExport, post_response } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

import c_add from "./Add.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_add,
  },
  props: {
    meeting_id: Number,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_id = props.meeting_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.list_data;

      meeting_service_pickup_car_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          // state.list_data = list.map((m) => {
          //   return {
          //     ...m,
          //     list: [
          //       {
          //         date: "2026-08-08",
          //         list: [
          //           {
          //             lx: "接机/站",
          //             ck: "王庆红",
          //             dh: "18000000001",
          //             cc: "CA1831",
          //             jksj: "18:00",
          //             jkdd: "合肥新桥机场",
          //             yjsd: "09:25",
          //             sddd: "双龙商务大酒店",
          //             sm: "不要打电话，拿牌子等着",
          //           },
          //           {
          //             lx: "接机/站",
          //             ck: "王庆红",
          //             dh: "18000000001",
          //             cc: "CA1831",
          //             jksj: "18:00",
          //             jkdd: "合肥新桥机场",
          //             yjsd: "09:25",
          //             sddd: "双龙商务大酒店",
          //             sm: "不要打电话，拿牌子等着",
          //           },
          //         ],
          //       },
          //       {
          //         date: "2026-08-09",
          //         list: [
          //           {
          //             lx: "接机/站",
          //             ck: "王庆红",
          //             dh: "18000000001",
          //             cc: "CA1831",
          //             jksj: "18:00",
          //             jkdd: "合肥新桥机场",
          //             yjsd: "09:25",
          //             sddd: "双龙商务大酒店",
          //             sm: "不要打电话，拿牌子等着",
          //           },
          //           {
          //             lx: "接机/站",
          //             ck: "王庆红",
          //             dh: "18000000001",
          //             cc: "CA1831",
          //             jksj: "18:00",
          //             jkdd: "合肥新桥机场",
          //             yjsd: "09:25",
          //             sddd: "双龙商务大酒店",
          //             sm: "不要打电话，拿牌子等着",
          //           },
          //           {
          //             lx: "接机/站",
          //             ck: "王庆红",
          //             dh: "18000000001",
          //             cc: "CA1831",
          //             jksj: "18:00",
          //             jkdd: "合肥新桥机场",
          //             yjsd: "09:25",
          //             sddd: "双龙商务大酒店",
          //             sm: "不要打电话，拿牌子等着",
          //           },
          //         ],
          //       },
          //     ],
          //   };
          // });
          state.list_data = list;
          // state.list_data = [...state.list_data, ...state.list_data];
          // state.list_data = [...state.list_data, ...state.list_data];
          // state.list_data = [...state.list_data, ...state.list_data];
          // state.list_data = [...state.list_data, ...state.list_data];
          state.totalCount = count;
        }
      });
    };

    const onReset = () => {
      state.params = {
        meeting_id: props.meeting_id,
      };
    };

    //导出
    const onExport = () => {
      let data = {
        ...state.params,
      };
      data.page = 1;
      data.limit = 0;

      funcExport(meeting_service_pickup_car_export, data);
    };

    const onCancel = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-danger);">取消</strong>该排班吗？`,
        "取消",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_service_pickup_car_cancel({
          id: row.id,
        }).then((res) => {
          post_response(res, onLoad);
        });
      });
    };

    return { state, props, onLoad, onExport, onCancel, onReset };
  },
};
</script>

<style lang="scss" scoped>
.huiwu-jiesong-paiban-tab {
  width: 100%;
  table-layout: fixed; /* 关键：固定列宽 */
  border-collapse: collapse;
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 80px);

  thead {
    th {
      box-sizing: border-box;
      background: #f5f5f5;
      padding: 8px;
      border: 1px solid #999;
    }
  }

  tbody {
    display: block;
    flex: 1;
    overflow-y: auto; /* 垂直滚动 */
    overflow-x: hidden;

    td {
      box-sizing: border-box;
      width: 120px; /* 和th宽度完全一致！！ */
      padding: 8px;
      border: 1px solid #999;
    }
  }
}
</style>
